import React from 'react'
import { IconButton, Tooltip } from '@mui/material'
import { ContentCopy as ContentCopyIcon } from '@mui/icons-material'
import { useSnackbar } from '@/hooks/common/useSnackbar'
import { copyTextToClipboard } from '../utils/gridRowClipboard'

interface CopyGridRowButtonProps {
  getCopyText: () => string
}

const CopyGridRowButton: React.FC<CopyGridRowButtonProps> = ({ getCopyText }) => {
  const { showSuccess, showError } = useSnackbar()

  const handleCopy = async (event: React.MouseEvent) => {
    event.stopPropagation()
    const ok = await copyTextToClipboard(getCopyText())
    if (ok) {
      showSuccess('Row copied to clipboard')
    } else {
      showError('Could not copy to clipboard')
    }
  }

  return (
    <Tooltip title="Copy row details">
      <IconButton size="small" onClick={(e) => void handleCopy(e)} aria-label="Copy row details">
        <ContentCopyIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  )
}

export default CopyGridRowButton
